import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    ticketData: [],
    category: [],
    idCategoryChecked: ''
}

export const ticketSlice = createSlice(
    {
        name: 'base',
        initialState,
        reducers: {
            setTicketData: (state, actions) => {
                state.ticketData = actions.payload
            },
            setCategory: (state, actions) => {
                state.category = actions.payload
            },
            setIdCategoryChecked: (state, actions) => {
                state.idCategoryChecked = actions.payload
            }

        }

    }
)


export default ticketSlice.reducer
export const ticketAction = ticketSlice.actions
export const ticketDataSelector = (state) => state.ticketReducer
